
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class PsSetItemGrid extends Serenity.EntityGrid<PsSetItemRow, any> {
        protected getColumnsKey() { return PsSetItemColumns.columnsKey; }
        protected getDialogType() { return PsSetItemDialog; }
        protected getIdProperty() { return PsSetItemRow.idProperty; }
        protected getInsertPermission() { return PsSetItemRow.insertPermission; }
        protected getLocalTextPrefix() { return PsSetItemRow.localTextPrefix; }
        protected getService() { return PsSetItemService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();

            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PsSetItemService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;

                    },
                }
            );


            return buttons;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["CustGroupName"]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }
        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();
            //--set new set of grid columns---
            //--get content width
            //slick-viewport slick-viewport-top slick-viewport-left
            let ele = document.getElementsByClassName("slick-viewport");
            var bordermg = 60;
            var eleWidth = ele.item(0).clientWidth - bordermg * 5;
            var totalcolw = 0;
            //---100,260,600,120,100,220,220 = 1620 = base (wide screen)
            //---1469 - notebook, --1135 when have menu 
            let propItems = this.getPropertyItems();
            let items = this.getColumns();
            items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                totalcolw += pItem.width;

            });
            items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                pItem.resizable = true;
                pItem.width = (eleWidth / totalcolw) * pItem.width;
              

            });
            let c = this.postProcessColumns(this.propertyItemsToSlickColumns(propItems));
            this.slickGrid.setColumns(c);
            this.slickGrid.resizeCanvas();


            return this.slickGrid;
        }
    }
}